import { DEFAULT_USER_INFO_STATE } from './useUserInfoStore.js';
export const getActions = (set) => ({
    resetState: () => {
        set(DEFAULT_USER_INFO_STATE);
    },
    setEmail: email => {
        set({ email });
    },
    setPhone: phone => {
        set({ phone });
    },
    setCountryCode: countryCode => {
        set({ countryCode });
    },
});
